export const baseUrl = 'order';
export const subscriptionBaseUrl = 'subscriptions';

export const OrderApi = {
  order: `${baseUrl}`,
  getRewardCode: (orderId: string) => `${subscriptionBaseUrl}/rewards/${orderId}`
};
